import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ParameterMasterRoutingModule } from './parameter-master-routing.module';
import { HolidayMasterComponent } from './holiday-master/holiday-master.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';


@NgModule({
  declarations: [HolidayMasterComponent],
  imports: [
    CommonModule,
    ParameterMasterRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule
  ]
})
export class ParameterMasterModule { }
